import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './StaticPage.css';

const SUPPORT_EMAIL = 'adrian.ciuca.dev@gmail.com';

const FlappyFishPrivacy = () => {
  const { t } = useLanguage();

  return (
    <div className="static-page">
      <section className="static-page-hero">
        <h1>{t('flappyFish.privacyTitle')}</h1>
      </section>
      <section className="static-page-body">
        <div className="container static-page-prose">
          <p className="static-page-meta">{t('flappyFish.lastUpdated')}</p>
          <p>{t('flappyFish.intro')}</p>
          <p>
            {t('flappyFish.developerLabel')}: Adrian Ciuca
            <br />
            {t('flappyFish.contactLabel')}:{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>

          <h2>{t('flappyFish.onDeviceTitle')}</h2>
          <ul>
            <li>{t('flappyFish.onDeviceScores')}</li>
            <li>{t('flappyFish.onDeviceSettings')}</li>
          </ul>

          <h2>{t('flappyFish.gameCenterTitle')}</h2>
          <p>{t('flappyFish.gameCenterBody')}</p>

          <h2>{t('flappyFish.notDoTitle')}</h2>
          <ul>
            <li>{t('flappyFish.notDoAccount')}</li>
            <li>{t('flappyFish.notDoSell')}</li>
            <li>{t('flappyFish.notDoAds')}</li>
            <li>{t('flappyFish.notDoSensitive')}</li>
          </ul>

          <h2>{t('flappyFish.childrenTitle')}</h2>
          <p>{t('flappyFish.childrenBody')}</p>

          <h2>{t('flappyFish.changesTitle')}</h2>
          <p>{t('flappyFish.changesBody')}</p>

          <h2 id="support">{t('flappyFish.supportTitle')}</h2>
          <p>{t('flappyFish.supportBody')}</p>
          <p>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default FlappyFishPrivacy;
